import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './dashboard.component.html',
  standalone: false
})
export class DashboardComponent implements OnInit {

  constructor() {

  }

  ngOnInit(): void {

  }

}
